import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardAttributeDb } from '../redux/cardAttributeDbSlice';

const useCardAttributeDbs = (cardId: string | undefined): [string[], CardAttributeDb[]] => {
  const cardAttributeDb = useSelector((state: RootState) => state.cardAttributeDb);
  const ids = Object.keys(cardAttributeDb.cardAttributes).filter(id => cardAttributeDb.cardAttributes[id].cardId === cardId);
  ids.sort((a, b) => {
    const aValue = cardAttributeDb.cardAttributes[a];
    const bValue = cardAttributeDb.cardAttributes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => cardAttributeDb.cardAttributes[id]);

  return [ids, values];
}

export default useCardAttributeDbs;
